import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {IStore} from '../../redux/interface';
import {Link, useParams} from 'react-router-dom';
import {FormattedMessage} from 'react-intl';
import {useGetTranslations} from '../../utils/hooks/useGetTranslations';
import {TranslationKeys} from '../../utils/constants/routeConstants';
import {
  articleAsyncActions, getTeiArticleReference
} from '../../redux/pageAsyncActions';
import {closeArticleReference} from '../../redux/article/actions';
import Loader from '../../components/loader';
import {doiUrl} from '../../utils/constants/constants';
import './styles.scss';

export const ArticleReference: React.FunctionComponent = () => {
  const {
    reference
  } = useSelector((state: IStore) => state.article);
  const {
    loading
  } = useSelector((state: IStore) => state.status);
  const dispatch = useDispatch();
  const {articleId, referenceId} = useParams();

  useGetTranslations({
    translationKey: TranslationKeys.Article
  });

  useEffect(() => {
    dispatch(closeArticleReference());
    if (articleId && referenceId) {
      dispatch(articleAsyncActions[getTeiArticleReference](articleId, referenceId));
    }
  }, [articleId, referenceId]);

  return <div className="reference-page">
    {!reference && loading.includes(getTeiArticleReference) && <Loader className="reference-page__loader"/>}
    {reference && <header className="reference-page__header">
      <h1>{reference.title || <FormattedMessage
        id={'gritx.article.reference'}
        defaultMessage={'Reference'}
      />}</h1>
      <Link to={`/article/${reference.articleId}`} className="reference-page__link">
        <FormattedMessage
          id={'gritx.article.backToArticle'}
          defaultMessage={'Back to article'}
        /></Link>
      <Link to={`/article/references/${reference.articleId}`} className="reference-page__link">
        <FormattedMessage
          id={'gritx.article.backToReferences'}
          defaultMessage={'Back to References'}
        /></Link>
      <p className="reference-page__authors reference-page__line">
        <Link className="reference-page__link" to={`/article/reference/authors/${reference.articleId}/${reference.id}`}>{reference.authors}</Link>
      </p>
      {reference.date && <p className={'reference-page__line'}>
        <FormattedMessage
          id={'gritx.article.firstPublished'}
          defaultMessage={'First published'}
        />: {reference.date}
      </p>}
      {reference.doi && <p className={'reference-page__line'}>
        {reference.publicationTitle}: <a href={`${doiUrl}${reference.doi}`} className="reference-page__link" target="_blank"
          rel="noreferrer">{doiUrl}{reference.doi}</a>
      </p>}
    </header>}
    {reference && <section className="reference-page__meta-links">
      <div className="reference-page__body">
        <FormattedMessage
          id={'gritx.article.references'}
          defaultMessage={'References'}
        />: {reference.referenceCount}
      </div>
    </section>}
  </div>;
};
